module.exports = __webpack_public_path__ + "img/jbt3411_67_1999.prt.5f301aab.jpg";